var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMachineBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_machine_blue"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_machine_blue",
    clipPath: "url(#clip-icon_machine_blue)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(-143.615 -250.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    d: "M1.538-.5H14.094a2.038,2.038,0,0,1,0,4.076H1.538a2.038,2.038,0,0,1,0-4.076ZM14.094,2.576a1.038,1.038,0,0,0,0-2.076H1.538a1.038,1.038,0,0,0,0,2.076Z",
    transform: "translate(150.02 267.636)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M157.836,266.923h-6.605a.5.5,0,0,1-.5-.5V262.13a.5.5,0,0,1,.069-.254l2.532-4.294a.5.5,0,0,1,.431-.246h4.073a.5.5,0,0,1,.5.5v8.587A.5.5,0,0,1,157.836,266.923Zm-6.105-1h5.605v-7.587h-3.288l-2.318,3.93Z",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    d: "M0-.5H6.331a.5.5,0,0,1,.5.5V3.523a.5.5,0,0,1-.5.5H0a.5.5,0,0,1-.5-.5V0A.5.5,0,0,1,0-.5ZM5.831.5H.5V3.023H5.831Z",
    transform: "translate(157.836 262.9)",
    fill: "#377EF3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M149.275,265.742h-3.7a.5.5,0,0,1-.5-.5V261.58a.5.5,0,0,1,.852-.355l3.7,3.663a.5.5,0,0,1-.352.855Zm-3.2-1h1.982l-1.982-1.964Z",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M145.577,262.08a.5.5,0,0,1-.465-.683l3.047-7.777a.5.5,0,0,1,.819-.171l4.729,4.729a.5.5,0,1,1-.707.707l-4.188-4.188-2.768,7.066A.5.5,0,0,1,145.577,262.08Z",
    fill: "#377EF3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMachineBlue);
export default __webpack_public_path__ + "static/media/icon_machine_blue.89c8797d296369ab16bed0400852a269.svg";
export { ForwardRef as ReactComponent };